import { Link, useLocation } from 'react-router-dom';
import { Play, Calendar, Users, User, LogIn, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';

export function Navigation() {
  const { user, signOut } = useAuth();
  const location = useLocation();

  const navItems = [
    { to: '/play', label: 'Play', icon: Play },
    { to: '/daily', label: 'Daily', icon: Calendar },
    { to: '/leagues', label: 'Leagues', icon: Users },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="border-b border-border/40 bg-background/95 backdrop-blur-sm sticky top-0 z-40">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-14">
          <Link to="/" className="text-lg font-semibold text-foreground hover:text-primary transition-colors">
            WikiRound
          </Link>

          <div className="flex items-center gap-1">
            {navItems.map((item) => (
              <Link key={item.to} to={item.to} aria-label={item.label}>
                <Button
                  variant={isActive(item.to) ? 'secondary' : 'ghost'}
                  size="sm"
                  className={`gap-2 ${isActive(item.to) ? 'text-primary' : 'text-muted-foreground hover:text-foreground'}`}
                  aria-label={item.label}
                >
                  <item.icon className="w-4 h-4" aria-hidden="true" />
                  <span className="hidden sm:inline">{item.label}</span>
                </Button>
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-1">
            {user ? (
              <>
                <Link to="/profile" aria-label="Profile">
                  <Button 
                    variant={isActive('/profile') || isActive('/settings') ? 'secondary' : 'ghost'} 
                    size="sm" 
                    className={`gap-2 ${isActive('/profile') || isActive('/settings') ? 'text-primary' : 'text-muted-foreground hover:text-foreground'}`}
                    aria-label="Profile"
                  >
                    <User className="w-4 h-4" aria-hidden="true" />
                    <span>Profile</span>
                  </Button>
                </Link>
                <Button 
                  variant="ghost" 
                  size="sm" 
                  onClick={signOut}
                  className="gap-2 text-muted-foreground hover:text-foreground"
                  aria-label="Sign Out"
                >
                  <LogOut className="w-4 h-4" aria-hidden="true" />
                  <span className="hidden sm:inline">Sign Out</span>
                </Button>
              </>
            ) : (
              <Link to="/auth" aria-label="Sign In">
                <Button variant="outline" size="sm" className="gap-2" aria-label="Sign In">
                  <LogIn className="w-4 h-4" aria-hidden="true" />
                  <span className="hidden sm:inline">Sign In</span>
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
